import $http from '../../axios';
import { Notification, MessageBox } from "element-ui";

export async function fetchContactsWrong({ state, commit }) {
    await $http.get('/api/terceros-lite', { params: state.params_contact_wrong }).then(response => {
        commit('setContactsWrong', response.data.data);
    }).catch(error => {
        Notification.error({
            title: "Error!",
            message: error.message,
            type: "error",
            duration: 3000,
            customClass: "notification-box"
        });
    });
}

export async function fetchContactsCorrect({ state, commit }) {
    await $http.get('/api/terceros-lite', { params: state.params_contact_correct }).then(response => {
        commit('setContactsCorrect', response.data.data);
    }).catch(error => {
        Notification.error({
            title: "Error!",
            message: error.message,
            type: "error",
            duration: 3000,
            customClass: "notification-box"
        });
    });
}

export async function fetchWarehousesWrong({ commit }, contactId) {
    await $http.get('/api/sucursales', { params: { contact_id: contactId } }).then(response => {
        commit('setWarehousesWrong', response.data);
    }).catch(error => {
        Notification.error({
            title: "Error!",
            message: error.message,
            type: "error",
            duration: 3000,
            customClass: "notification-box"
        });
    });
}

export async function fetchWarehousesCorrect({ commit }, contactId) {
    await $http.get('/api/sucursales', { params: { contact_id: contactId } }).then(response => {
        commit('setWarehousesCorrect', response.data);
    }).catch(error => {
        Notification.error({
            title: "Error!",
            message: error.message,
            type: "error",
            duration: 3000,
            customClass: "notification-box"
        });
    });
}

export async function fetchInconsistentContacts({ state, commit }) {
    state.loading.module = true;

    await $http.get('/api/unificar-terceros-listar').then(response => {
        commit('setInconsistentContacts', response.data.data);
    }).catch(error => {
        Notification.error({
            title: "Error!",
            message: error.message,
            type: "error",
            duration: 3000,
            customClass: "notification-box"
        });
    }).finally(() => {
        state.loading.module = false;
    });
}

export async function unifyContacts({ state, commit }) {
    state.loading.module = true;

    return await $http.post('/api/unificar-terceros', state.unifyParam).then(async response => {
        Notification.success({
            title: "success!",
            message: response.data.message || "Proceso finalizado con éxito",
            type: "success",
            duration: 3000,
            customClass: "notification-box"
        });

        commit('resetUnifyParam');
        await fetchInconsistentContacts({ state, commit });

        return true;
    }).catch(error => {
        const message = (error.response && error.response.data && error.response.data.message) || error.message;

        MessageBox.alert(message, "Error", {
            confirmButtonText: "Aceptar",
            type: "error",
            customClass: "notification-error"
        });

        return false;
    }).finally(() => {
        state.loading.module = false;
    });
}



// WEBPACK FOOTER //
// ./src/modules/unify-contacts/actions.js